import { AxiosPromise } from 'axios'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import _ from 'lodash'
import type {
  IcsAdvertiserDataConfig,
  queryOptionConfig,
} from '@/api/ics_advertiser/manage.type'
import { CheckSearchQuery } from '@/views/producer/ics-authorization/authorization-option'
import { IcsAdvertiserConfig } from '@/api/ics_advertiser/manage.type'

export function fetchICSAdvertiserList(
  data?: queryOptionConfig,
): AxiosPromise<IcsAdvertiserDataConfig> {
  return request({
    url: v2Host + '/ics/api-u/pt/listAccount',
    method: 'post',
    data: CheckSearchQuery(_.cloneDeep(data)),
  })
}

export function createICSAdvertiser(data?: IcsAdvertiserConfig): AxiosPromise {
  return request({
    url: v2Host + '/ics/api-u/pt/authorizationIcs',
    method: 'post',
    data,
  })
}

export function updateICSAdvertiser(data?: IcsAdvertiserConfig): AxiosPromise {
  return request({
    url: v2Host + '/ics/api-u/pt/modifyAccountInfo',
    method: 'post',
    data,
  })
}

export function operationHistory(ssUid: number): AxiosPromise {
  return request({
    url: v2Host + '/ics/api-u/pt/operationHistory',
    method: 'get',
    params: {
      ssUid,
    },
  })
}

export function subAccounts(ssUid: number): AxiosPromise {
  return request({
    url: v2Host + '/ics/api-u/pt/subAccounts',
    method: 'get',
    params: {
      ssUid,
    },
  })
}

export function icsAdvertiserDownload(
  params: IcsAdvertiserConfig,
): AxiosPromise {
  return request({
    url: v2Host + '/ics/api-u/pt/exportAccountList',
    method: 'get',
    params: CheckSearchQuery(_.cloneDeep(params)),
  })
}
